import { ref, computed, onBeforeUnmount } from 'vue'

export function useResendTimer(initialCooldown: number = 30) {
  const resendCooldown = ref<number>(0)
  let resendTimer: ReturnType<typeof setInterval> | null = null

  const formattedResendTime = computed(() => {
    const minutes = Math.floor(resendCooldown.value / 60)
    const seconds = resendCooldown.value % 60
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
  })

  const canResend = computed(() => resendCooldown.value <= 0)

  const startCooldown = (cooldownSeconds?: number): void => {
    resendCooldown.value = cooldownSeconds ?? initialCooldown

    if (resendTimer) {
      clearInterval(resendTimer)
    }

    resendTimer = setInterval(() => {
      resendCooldown.value--
      if (resendCooldown.value <= 0) {
        if (resendTimer) {
          clearInterval(resendTimer)
          resendTimer = null
        }
      }
    }, 1000)
  }

  const stopCooldown = (): void => {
    if (resendTimer) {
      clearInterval(resendTimer)
      resendTimer = null
    }
    resendCooldown.value = 0
  }

  onBeforeUnmount(() => {
    stopCooldown()
  })

  return {
    resendCooldown,
    formattedResendTime,
    canResend,
    startCooldown,
    stopCooldown,
  }
}
